import React, { Component } from 'react';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { FILTERS, DEFAULT_SPECIALTY } from '../constants';

import './styles.scss';

class ConsultQueueFilters extends Component {
  specialtyNameForCode = (code) => {
    return this.props.filters.service_specialties.filter(specialty => specialty.value == code)[0].text;
  };

  render() {
    const { initialValues, applyFilters, filters, resetFilters } = this.props;

    const ageRangeFilter = (props, filterMeta) => {
      // Render age range field

      return (
        // Render BH filter options if BH is selected
        filterMeta.cookieName == 'filter_age_range' && (
          props.values.service_specialty == 'BEHAVHEALTH' ?
          filters[filterMeta.options].filter((age_range)=>{
            if(age_range["bh"] == true){
              return true
            }
          }).map(filterOption => (
            <option key={filterOption.value} value={filterOption.value}>
              {filterOption.text}
            </option>
          ))
          :
          // Render normal filter options if BH is not selected
          filters[filterMeta.options].filter((age_range)=>{
            if(age_range["bh"] == false){
              return true
            }
          }).map(filterOption => (
            <option key={filterOption.value} value={filterOption.value}>
              {filterOption.text}
            </option>
          ))
        )
      )
    }

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={ values => applyFilters(values, this.specialtyNameForCode(values.service_specialty)) }
      >
        {props => (
          <div className="consult-queue-filters">
            <div className="specialty-select">
              Specialty:{' '}
              <Field component="select"
                     name="service_specialty"
                     className={cn('consult-queue-filter', { dirty: props.values.service_specialty !== initialValues.service_specialty })}
              >
                {
                  filters['service_specialties'].map(filterOption => (
                    <option key={filterOption.value} value={filterOption.value}>
                      {filterOption.text}
                    </option>
                  ))
                }
              </Field>
            </div>
            <div>
              Filters:
              {
                FILTERS.map(filterMeta => {
                  return (
                    <Field component="select"
                          name={filterMeta.cookieName}
                          className={cn('consult-queue-filter', { dirty: props.values[filterMeta.cookieName] !== initialValues[filterMeta.cookieName], default: !initialValues[filterMeta.cookieName] })}
                          key={filterMeta.cookieName}
                          value={props.values[filterMeta.cookieName]}
                    >
                      <option key='' value=''>
                        {filterMeta.allLabel}
                      </option>

                      { filterMeta.cookieName != 'filter_state' && (
                        filterMeta.cookieName != 'filter_age_range' && (
                          filters[filterMeta.options].map(filterOption => (
                            <option key={filterOption.value} value={filterOption.value}>
                              {filterOption.text}
                            </option>
                          ))
                        )
                      )}
                      { filterMeta.cookieName == 'filter_state' && props.values.filter_country && (
                        filters[filterMeta.options][props.values.filter_country].map(filterOption => (
                          <option key={filterOption.value} value={filterOption.value}>
                            {filterOption.text}
                          </option>
                        ))
                      )}
                      {ageRangeFilter(props, filterMeta)}
                    </Field>
                  )
                })
              }
            </div>
            <button className='button apply-button' type="submit" onClick={props.handleSubmit}>Apply Filters</button>
            <a className='reset-link' onClick={ () => resetFilters(FILTERS, this.specialtyNameForCode(DEFAULT_SPECIALTY)) }>Reset</a>
          </div>
        )}
      </Formik>
    );
  }
}

ConsultQueueFilters.propTypes = {
  filters: PropTypes.shape({
    communication_methods: PropTypes.array,
    statuses: PropTypes.array,
    providers: PropTypes.array,
    cancellation_reasons: PropTypes.array,
    countries: PropTypes.array,
    states_by_country: PropTypes.object,
    service_specialties: PropTypes.array,
    consultation_origins: PropTypes.array,
    business_labels: PropTypes.array
  }),
  applyFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    communication_method: PropTypes.string,
    status: PropTypes.string,
    provider: PropTypes.string,
    cancellation_reason: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    service_specialty: PropTypes.string,
    consultation_origin: PropTypes.string,
    business_label: PropTypes.string
  })
};

export default ConsultQueueFilters;
